import abstractDynamicFieldEntry from '../_abstractComponent/DynamicFieldEntry';
import { hooks } from 'lib_ui-primitives';
const _p = {
    usePersistentState: hooks.usePersistentState
};

export const _private = _p;
/**
 * This component allows a user to select from a dropdown, at runtime, what type of
 * information (i.e. hNodeType) they would like to edit for a given relation (e.g. item:item).
 * That dropdown is then transformed into an input control for the selected hNodeType so
 * the user can actually enter a new value using that input control.
 *
 * It can be used for things like mass updates.
 * e.g.
 * 1) A user selectes "Asset Type" from the initial dropdown.
 * 2) The dropdown is transformed into another dropdown containing asset types.
 * 3) The user selects the desired asset type from that dropdown.
 * 4) The user scans a bunch of assets, changing them all to have the selected asset type.
 *
 * A plus button is provided, allowing multiple entries to be added (so that multiple types
 * of data can be edited at the same time).
 *
 * The list of valid fields for editing is based on the data dictionary for the
 * component's namespace/relation.
 */
export default function DynamicFieldEntry(props) {
    const { hNode } = props;
    // Our entries below will come from (and be updated to) localForage
    // and will contain the hNodes to edit/create the data which the user selects at runtime.
    // e.g. if the user selects "Asset Type" from the Fields dropdown, then the entries
    // will contain an hNode for a dropdown the user may use to select an Asset Type.
    const [entries, setEntries, entriesReady] = _p.usePersistentState(`dynamicEntries-${hNode.id}`, []);
    return abstractDynamicFieldEntry({ ...props, entries, setEntries, entriesReady });
}
